import { IApplicationState } from '../../types/redux';
import { IRequestFormSchema } from '../../types/requestFormSchema';

export const selectRequestFormSchema = (state: IApplicationState): IRequestFormSchema => state.requestFormSchema;
